import { render, staticRenderFns } from "./SettingsDropdown.vue?vue&type=template&id=3c9ea336&"
import script from "./SettingsDropdown.vue?vue&type=script&lang=ts&"
export * from "./SettingsDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsDropdown.vue?vue&type=style&index=0&id=3c9ea336&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports